Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textlikeAdjacentToAirmojiAfter = exports.textlikeAdjacentToAirmojiBefore = undefined;

var _airbnbPropTypes = require('airbnb-prop-types');

var _componentWithNamesOfHOCs = require('./componentWithNamesOfHOCs');

var _componentWithNamesOfHOCs2 = _interopRequireDefault(_componentWithNamesOfHOCs);

var _textlike = require('./textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _Airmoji = require('../../exp/Airmoji');

var _Airmoji2 = _interopRequireDefault(_Airmoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var airmojiValidator = (0, _componentWithNamesOfHOCs2['default'])(_Airmoji2['default']);

var textlikeAdjacentToAirmojiBefore = exports.textlikeAdjacentToAirmojiBefore = (0, _airbnbPropTypes.childrenSequenceOf)({ validator: airmojiValidator, min: 0, max: 1 }, { validator: _textlike2['default'], min: 1 });

var textlikeAdjacentToAirmojiAfter = exports.textlikeAdjacentToAirmojiAfter = (0, _airbnbPropTypes.childrenSequenceOf)({ validator: _textlike2['default'], min: 1 }, { validator: airmojiValidator, min: 0, max: 1 });


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/airmojiAdjacent.js
// module id = 156
// module chunks = 168707334958949